module.exports = "https://tutorchat.chegg.com/static/media/ic-graph.502cafbb.svg";